import type { useTRPC } from "@/trpc";

/** Keep the record's owner explicit at every shared vault transport boundary. */
export type CredentialVaultScope =
  | { kind: "provider"; userId: string }
  | {
      kind: "organization";
      organizationBusinessUnitId: string;
      providerUserId: string;
      credentialViewId?: string;
      expectedAffiliationId?: string;
    };

export function vaultFilesQueryOptions(
  trpc: ReturnType<typeof useTRPC>,
  scope: CredentialVaultScope,
) {
  if (scope.kind === "organization") {
    return trpc.credentials.listVaultFilesForBu.queryOptions({
      organizationBusinessUnitId: scope.organizationBusinessUnitId,
      providerUserId: scope.providerUserId,
      ...(scope.expectedAffiliationId
        ? { expectedAffiliationId: scope.expectedAffiliationId }
        : {}),
      credentialViewId: scope.credentialViewId,
    });
  }
  return trpc.credentials.listMyVaultFiles.queryOptions({
    switchUserId: scope.userId,
  });
}

export function vaultCandidatesQueryKey(
  trpc: ReturnType<typeof useTRPC>,
  scope: CredentialVaultScope,
) {
  if (scope.kind === "organization") {
    return trpc.credentials.listCandidatesForBu.queryKey({
      organizationBusinessUnitId: scope.organizationBusinessUnitId,
      providerUserId: scope.providerUserId,
      ...(scope.expectedAffiliationId
        ? { expectedAffiliationId: scope.expectedAffiliationId }
        : {}),
    });
  }
  return trpc.credentials.listMyCandidates.queryKey({
    switchUserId: scope.userId,
  });
}

export function vaultScopeKey(scope: CredentialVaultScope) {
  if (scope.kind === "organization") {
    return `organization:${scope.organizationBusinessUnitId}:${scope.providerUserId}:${scope.credentialViewId ?? "current"}${scope.expectedAffiliationId ? `:${scope.expectedAffiliationId}` : ""}`;
  }
  return `provider:${scope.userId}`;
}

export function vaultSubjectUserId(scope: CredentialVaultScope) {
  return scope.kind === "organization" ? scope.providerUserId : scope.userId;
}

export function vaultRecordQueryKey(
  trpc: ReturnType<typeof useTRPC>,
  scope: CredentialVaultScope,
) {
  if (scope.kind === "organization") {
    return trpc.credentials.getForBu.queryKey({
      organizationBusinessUnitId: scope.organizationBusinessUnitId,
      providerUserId: scope.providerUserId,
      ...(scope.expectedAffiliationId
        ? { expectedAffiliationId: scope.expectedAffiliationId }
        : {}),
      credentialViewId: scope.credentialViewId,
    });
  }
  return trpc.credentials.getMyCredentials.queryKey({
    switchUserId: scope.userId,
  });
}

export function vaultCandidatesQueryOptions(
  trpc: ReturnType<typeof useTRPC>,
  scope: CredentialVaultScope,
) {
  if (scope.kind === "organization") {
    return trpc.credentials.listCandidatesForBu.queryOptions({
      organizationBusinessUnitId: scope.organizationBusinessUnitId,
      providerUserId: scope.providerUserId,
      ...(scope.expectedAffiliationId
        ? { expectedAffiliationId: scope.expectedAffiliationId }
        : {}),
    });
  }
  return trpc.credentials.listMyCandidates.queryOptions({
    switchUserId: scope.userId,
  });
}
